import { library } from '@fortawesome/fontawesome-svg-core';
import { faChartPie, faChevronLeft, faSearch } from '@fortawesome/free-solid-svg-icons';

library.add(
    faChartPie,
    faChevronLeft,
    faSearch
);